
import { Divider, Grid } from "@mui/material"

import moment from "moment";

import { InfoField } from "./InfoField";

interface Props {
    numeroSeguimiento:      string;
    fecha:                  Date;
    juez?:                  string;
    numeroOficio?:          string;
    numeroBoleta?:          string;
    numeroExhorto?:         string;
}

export const BoxHeaderInformacion = ( { numeroSeguimiento, fecha, juez, numeroOficio, numeroBoleta, numeroExhorto }: Props ) => {

    return (
        <Grid container spacing={3}>                             
                            
            <Grid size={{ md: ( numeroOficio || numeroBoleta || numeroExhorto ) ? 3 : 4, xs: 12 }}>

                <InfoField
                    label="Número de seguimiento" 
                    value={ numeroSeguimiento }
                    fontSize={ 22 }
                />    
                
            </Grid>    

            <Grid size={{ md: ( numeroOficio || numeroBoleta || numeroExhorto ) ? 3 : 4, xs: 12 }}>

                <InfoField
                    label="Fecha" 
                    value={ moment( fecha ).format( 'DD-MM-YYYY hh:mm a' ) }
                    fontSize={ 22 }
                />    
                                
            </Grid>    

            {
                numeroOficio
                &&                
                    <Grid size={{ md: 2, xs: 12 }}>
                
                        <InfoField
                            label="Número de oficio" 
                            value={ numeroOficio }
                    fontSize={ 22 }
                        />    
                        
                    </Grid>                    
            }    

            {
                numeroBoleta
                &&                
                    <Grid size={{ md: 2, xs: 12 }}>

                        <InfoField
                            label="Número de boleta" 
                            value={ numeroBoleta }
                            fontSize={ 22 }
                        />                          
                        
                    </Grid>                    
            }    

            {
                numeroExhorto
                &&                
                    <Grid size={{ md: 2, xs: 12 }}>

                        <InfoField
                            label="Número de exhorto" 
                            value={ numeroExhorto }
                            fontSize={ 22 }
                        />                          
                        
                    </Grid>                    
            }    

            {
                juez
                &&                
                    <Grid size={{ md: 4, xs: 12 }}>

                        <InfoField
                            label="Juez(a)" 
                            value={ juez }
                            fontSize={ 22 }
                        />        
                        
                    </Grid>                    
            }    

            <Grid size={{ md: 12, xs: 12 }}>

                <Divider sx={{ my: 1 }} />

            </Grid>

        </Grid>      
    )
}
